import React, { useCallback, useState } from 'react';
import PT from 'prop-types';
import { Flex } from '@procore/core-react';
import { SlickWrapper } from '@/react/styles/v2';
import { sendAnalytics } from '../../utils';
import ImageModal from './ImageModal';
import MainCarousel from './MainCarousel';
import ThumbnailCarousel from './ThumbnailCarousel';

const MediaCarousel = ({
  screenshots,
  wistiaId,
  appName,
  tagline,
  logoURL,
}) => {
  const [mainCarousel, setMainCarousel] = useState(null);
  const [thumbnailCarousel, setThumbnailCarousel] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [currentImageUrl, setCurrentImageUrl] = useState('');

  const handleBeforeChange = useCallback(
    (_, next) => {
      sendAnalytics('click', 'Media Slider', next, 'media_slider.changed', {
        index: next,
      });
      setCurrentImageUrl(
        next === 0 && wistiaId
          ? ''
          : screenshots[wistiaId ? next - 1 : next]?.url
      );
    },
    [screenshots, wistiaId]
  );

  return (
    <>
      {screenshots?.length > 0 && (
        <ImageModal
          logoURL={logoURL}
          appName={appName}
          tagline={tagline}
          isOpen={imageModalOpen}
          imageURL={currentImageUrl || screenshots[0]?.url}
          onClose={() => setImageModalOpen(false)}
          slides={screenshots}
        />
      )}

      <Flex direction="column" gap="xxl">
        <SlickWrapper marginTop="md" data-testid="media-section">
          {/* Main Carousel */}
          <MainCarousel
            screenshots={screenshots}
            wistiaId={wistiaId}
            onBeforeChange={handleBeforeChange}
            setMainCarousel={setMainCarousel}
            thumbnailCarousel={thumbnailCarousel}
            openImageModal={() => setImageModalOpen(true)}
          />
        </SlickWrapper>

        {/* Thumbnail Carousel */}
        <SlickWrapper className="thumbnail-carousel" marginTop="sm">
          <ThumbnailCarousel
            screenshots={screenshots}
            wistiaId={wistiaId}
            setThumbnailCarousel={setThumbnailCarousel}
            mainCarousel={mainCarousel}
          />
        </SlickWrapper>
      </Flex>
    </>
  );
};

MediaCarousel.propTypes = {
  screenshots: PT.arrayOf(
    PT.shape({
      url: PT.string.isRequired,
    })
  ),
  wistiaId: PT.string,
  appName: PT.string.isRequired,
  tagline: PT.string.isRequired,
  logoURL: PT.string.isRequired,
};

export default MediaCarousel;
